import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=333ed871&scoped=true&"
import script from "./productCenter.vue?vue&type=script&lang=js&"
export * from "./productCenter.vue?vue&type=script&lang=js&"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=333ed871&lang=scss&scoped=true&"
import style1 from "./productCenter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333ed871",
  null
  
)

export default component.exports